import React, { ReactElement } from 'react';
import EmptyBase from 'pages/Orders/components/OrderItem/components/EmptyBase';
import ShareIcon from 'components/Icons/ShareIcon';
import QuestionIcon from 'components/Icons/QuestionIcon';
import { getUrlParams } from 'utils/urlParams';
import { sendEventToDelphoi } from 'utils/send';
import { isTestUser } from 'utils/isInternalUser';
import { isAndroid } from 'utils/platform';
import history from 'configs/history';
import { useModal } from 'contexts/ModalProvider';
import { functionExistsForNativeAndroidInterface } from 'utils/native';
import { createDelphoiData } from 'utils/delphoiHelper';
import styles from './RafflePageTopBarIconGroup.module.scss';
import getRaffleConfigs from '../../Raffle.config';
import { onCopy } from '../../helpers/onCopy/onCopy';

function RafflePageTopBarIconGroup(): ReactElement {
  const modal = useModal();
  const { showShareButton } = getRaffleConfigs();

  function openFaqPage() {
    const tab = getUrlParams().get('tab') ?? 'unknown';
    sendEventToDelphoi(
      createDelphoiData({
        action: 'faqclick',
        event: 'lottery',
        tv023: 'digital_services_raffle',
        tv070: tab,
      })
    );
    history.push('/raffles/faq');
  }

  function openShare() {
    if (navigator.share) {
      try {
        navigator
          .share({
            title: 'Trendyol Şanslı Çekiliş',
            text:
              'Biletini al, Şanslı Çekiliş’e katıl, hayalindeki ürünleri kazanma fırsatını kaçırma!',
            url: 'https://www.ty.gl/sansli-cekilis-trendyol',
          })
          .catch(function (error) {
            console.log('Error sharing: ', error);
          });
        // eslint-disable-next-line no-empty
      } catch (e) {}
    } else {
      onCopy('https://www.ty.gl/sansli-cekilis-trendyol');
      modal({
        type: 'success',
        title: 'Trendyol Şanslı Çekiliş linki kopyalandı!',
        description:
          'Linki sevdiklerinizle paylaşıp çekilişe katılmalarını sağlayabilirsiniz.',
        base: EmptyBase,
      });
    }
  }

  const copyExistForAndroid =
    isAndroid() && functionExistsForNativeAndroidInterface('copyToClipboard');
  const showShareButtonOnAndroid =
    (isTestUser() || showShareButton) && copyExistForAndroid;
  const showShareButtonOnIos =
    (isTestUser() || showShareButton) && !isAndroid();

  return (
    <div className={styles.topBarIconsWrapper}>
      {(showShareButtonOnAndroid || showShareButtonOnIos) && (
        <ShareIcon className={styles.shareIcon} onClick={openShare} />
      )}
      <QuestionIcon onClick={openFaqPage} />
    </div>
  );
}

export default RafflePageTopBarIconGroup;
